import Cookie from '@/helper/cookie.js'

export default {
    logout: () => {
        Cookie.delete()
        localStorage.clear()
    }
}